import React from 'react'
import PropTypes from 'prop-types'
import {
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from "react-accessible-accordion";

const propTypes = {
  question: PropTypes.object,
  answer: PropTypes.object,
  uniqueID: PropTypes.number
}

const AccordionWrapper = (props) => (
  <AccordionItem>
      <AccordionItemTitle id={props.uniqueID}>
          {props.question}
          <span className="accordion__arrow"></span>
      </AccordionItemTitle>
      <AccordionItemBody>
          {props.answer}
      </AccordionItemBody>
  </AccordionItem>
)

AccordionWrapper.propTypes = propTypes

export default AccordionWrapper


// WEBPACK FOOTER //
// ./src/components/AccordionWrapper.js